'use client'
import { useTranslations } from 'next-intl'
import { tw } from 'utils/classnames'

import { useLikeProduct } from '@web/hooks/use-product-like-actions'
import { HeartIcon } from '@web/components/icons/heart'

interface LikeButtonProps {
  productId: string
}

export function LikeButton(props: LikeButtonProps) {
  const t = useTranslations('prod.product_description_page.favorite')
  const { isLiked, isLoading, onClick } = useLikeProduct(props.productId)

  return (
    // oxlint-disable-next-line react/button-has-type
    <button
      onClick={onClick}
      disabled={isLoading}
      className="rounded-4 min-[960px]:hover:shadow-cf-elevation-light-1 group flex min-w-[130px] items-center justify-center border border-[#DFDDE5] px-4 py-2"
    >
      <HeartIcon isFavorite={isLiked} className="size-4 text-[#E21743]" />
      <span className={tw('text-14 ml-2', isLiked && 'group-hover:hidden')}>
        {isLiked ? t('favorited') : t('add')}
      </span>
      <span className={tw('text-14 ml-2 hidden', isLiked && 'group-hover:inline-block')}>
        {t('unfavorite')}
      </span>
    </button>
  )
}
